











import UserRegistrationForm from '@checkout-organisms/auth/registration-form/UserRegistrationForm.vue';
import { defineComponent } from '@nuxtjs/composition-api';
import LegalLinks from 'organisms/LegalLinks.vue';

import { useSocialLogin } from '~/diptyqueTheme/composable';

export default defineComponent({
  name: 'RegistrationSection',
  components: {
    LegalLinks,
    VaimoSocialLogin: () => import('organisms/VaimoSocialLogin.vue'),
    UserRegistrationForm
  },
  setup() {
    const { isSocialLoginEnabled } = useSocialLogin();
    return {
      isSocialLoginEnabled
    };
  }
});
